export enum HELP_PAGE {
  Api_Configuration = 226,
  Patient = 227,
  Patient_Logs = 228,
  Mco_PatPlan_Configurations = 229,
  Queries = 248,
}
